import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { Grommet } from 'grommet';
import { CustomTheme } from '../styles/CustomTheme';
import Webfonts from '../styles/Webfonts';
import GrommetTheme from '../styles/GrommetTheme';
import GlobalStyle from '../styles/GlobalStyle';
import Footer from './Footer';
import Header from './Header';
import { storeUTMParams, pushToElqQ } from '../utilities/tracking';

const StyledPage = styled.div`
  /**
   * Establishes a sticky header and footer.
   */

  height: 100%;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
  display: flex;

  main {
    margin-top: var(--headerHeight);
    flex: 1 1 100%;

    display: flex;
    flex-direction: column;
  }
`;

/**
 * This is the entry point for all pages, and replaces the
 * Gatsby v1 Layout component.
 *
 */

const Page = ({ children }) => {
  useLayoutEffect(() => {
    pushToElqQ();
    storeUTMParams();
  }, []);
  const theme = { ...GrommetTheme, custom: { ...CustomTheme } };
  return (
    <Grommet theme={theme}>
      <GlobalStyle />
      <Webfonts />
      <StyledPage>
        <Helmet
          htmlAttributes={{
            lang: 'en',
          }}
        >
          <meta name="referrer" content="no-referrer-when-downgrade" />
        </Helmet>
        <Header />
        <main>{children}</main>
        <Footer />
      </StyledPage>
    </Grommet>
  );
};

Page.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Page;
